module.exports = __webpack_public_path__ + "img/icon-borrow-ebt-usdt.2ad55573.svg";